import { graphql } from 'parkdepot-shared/gql'

const B2C_GET_ORDER_INVOICE = graphql(`
    query B2CGetOrderInvoice($order_id: String!) {
        b2c_get_invoice(order_id: $order_id) {
            invoice_id
            url
        }
    }
`)

export default B2C_GET_ORDER_INVOICE
